var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavManageUrls = function SvgNavManageUrls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#8FB4EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 38c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-2.29-2.333A17.9 17.9 0 0 1 24.027 29h-3.965a8.008 8.008 0 0 0 5.648 6.667ZM26.03 29c.151 2.439.848 4.73 1.97 6.752A15.906 15.906 0 0 0 29.97 29h-3.94Zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 35.938 29Zm-15.876-2h3.965a17.9 17.9 0 0 1 1.683-6.667A8.008 8.008 0 0 0 20.062 27Zm5.969 0h3.938A15.904 15.904 0 0 0 28 20.248 15.906 15.906 0 0 0 26.03 27h.001Zm4.259-6.667A17.9 17.9 0 0 1 31.973 27h3.965a8.008 8.008 0 0 0-5.648-6.667Z",
    fill: "#1874FD"
  })));
};

export default SvgNavManageUrls;